// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProductResourceItem_buttonWrap__sJ0oh button {
  width: 75px;
}
`, "",{"version":3,"sources":["webpack://./src/selling-plan-products-page/ProductResourceItem.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb","sourcesContent":[".buttonWrap button {\n  width: 75px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonWrap": `ProductResourceItem_buttonWrap__sJ0oh`
};
export default ___CSS_LOADER_EXPORT___;
